import VaultMatrix from '../components/Vault';

const Tasks = () => (
  <div>
    <VaultMatrix />
  </div>
);

export default Tasks;
